import { render, staticRenderFns } from "./erweimaorder.vue?vue&type=template&id=313e986c&scoped=true&"
import script from "./erweimaorder.vue?vue&type=script&lang=js&"
export * from "./erweimaorder.vue?vue&type=script&lang=js&"
import style0 from "./erweimaorder.vue?vue&type=style&index=0&id=313e986c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313e986c",
  null
  
)

export default component.exports